import cx from 'classnames'

import Button from 'common/components/button'
import Emoji from 'common/emoji'

type Props = {
  title: string
  subtitle: string
  emoji: string
  isDisabled?: boolean
}

const SourceButton = ({ title, subtitle, emoji, isDisabled }: Props) => {
  return (
    <Button
      size="xl"
      disabled={isDisabled}
      className={cx(
        'h-auto p-6 bg-coolGray-50 border border-coolGray-300 border-dashed rounded flex flex-1 flex-col justify-items-center items-center gap-4 justify-around'
      )}
    >
      <div className="flex gap-4 items-center">
        <Emoji symbol={emoji} className="text-3xl" />
        <span className="text-coolGray-800 font-bold text-base">{title}</span>
      </div>{' '}
      <div className="items-center text-base text-coolGray-400">{subtitle}</div>
    </Button>
  )
}
export default SourceButton
